type Props = { name: string; email: string }

const EmployeeCell = ({ name, email }: Props): JSX.Element => (
  <td className="py-4 pr-4">
    <div className="font-medium text-dark-blue">{name}</div>
    <div className="text-lg text-stone-gray">{email}</div>
  </td>
)

export default EmployeeCell
